import { Link } from '@tanstack/react-router';
import type { ItemResponse } from '@triade/contracts';
import { SituacaoBadge } from './situacao-badge';
import { paraFiltro, ROTULO_CLASSIFICACAO, ROTULO_TIPO, situacaoDe, type BuscaItens } from './tipos';

export interface ItensTabelaProps {
  itens: ItemResponse[];
  /** Filtros da lista, levados ao detalhe para anterior/proximo seguirem a mesma ordem. */
  busca: BuscaItens;
  onAbrir: (i: ItemResponse) => void;
}

/** Grade densa da lista de itens (ordem fixa por codigo, a mesma do anterior/proximo). */
export function ItensTabela({ itens, busca, onAbrir }: ItensTabelaProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[800px] border-collapse text-small">
        <thead>
          <tr className="text-left text-caption text-ink-muted">
            <th scope="col" aria-sort="ascending" className="px-4 py-2.5 font-medium">Código</th>
            <th scope="col" className="px-3 py-2.5 font-medium">Descrição</th>
            <th scope="col" className="px-3 py-2.5 font-medium">Tipo</th>
            <th scope="col" className="px-3 py-2.5 font-medium">Classificação</th>
            <th scope="col" className="px-3 py-2.5 font-medium">Unidade</th>
            <th scope="col" className="px-4 py-2.5 font-medium">Situação</th>
          </tr>
        </thead>
        <tbody>
          {itens.map((i) => (
            <tr key={i.id} data-testid="linha-item-cadastro" onClick={() => onAbrir(i)} className="cursor-pointer border-t border-line-soft hover:bg-surface-muted">
              <td className="tabular px-4 py-3">
                <Link
                  to="/cadastros/itens/$id"
                  params={{ id: i.id }}
                  search={paraFiltro(busca)}
                  onClick={(e) => e.stopPropagation()}
                  className="font-semibold text-ink no-underline hover:underline"
                >
                  {i.codigo}
                </Link>
              </td>
              <td className="px-3 py-3">{i.descricao}</td>
              <td className="px-3 py-3 text-ink-secondary">{ROTULO_TIPO[i.tipo]}</td>
              <td className="px-3 py-3 text-ink-secondary">{i.tipo === 'PRODUTO' && i.classificacao ? ROTULO_CLASSIFICACAO[i.classificacao] : '—'}</td>
              <td className="px-3 py-3 text-ink-secondary">{i.unidade}</td>
              <td className="px-4 py-3">
                <div className="flex flex-wrap items-center gap-1.5">
                  <SituacaoBadge situacao={situacaoDe(i)} />
                  {i.semCusto && (
                    <span data-testid="marca-sem-custo" className="rounded-full bg-warning-bg px-2 py-0.5 text-caption font-semibold text-warning-ink">
                      sem custo
                    </span>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
